import { GameId } from '@bg-shared/enums/GameId';
import { BettingOptionsFormat } from '@betgames/bg-tools';
import {
    IWebSocketsBettingOption,
    IFormattedBettingOptions,
} from '@bg-shared/interfaces/IBettingOption';
import { ILegacyOptionsConfig } from '@bg-shared/business/GamesOptions/interfaces';
import { keyBy } from 'lodash-unified';
import { mapWebSocketsBettingOptions } from './mapWebSocketsBettingOptions';

interface IParams {
    gameId: GameId;
    format: BettingOptionsFormat;
    webSocketsOptions: IWebSocketsBettingOption[];
    apiOptions: ILegacyOptionsConfig;
}

export const mapAPIBettingOptionsWithWebSockets = (params: IParams): IFormattedBettingOptions => {
    const mappedWebSocketsOptions = mapWebSocketsBettingOptions({
        gameId: params.gameId,
        format: params.format,
        options: params.webSocketsOptions,
    });

    return keyBy(
        params.apiOptions.groups
            .flatMap((group) => group.options)
            .map((option) => ({
                ...option,
                ...mappedWebSocketsOptions[option.id],
                oddsClass: option.optionClass,
            })),
        'id',
    );
};
